module.exports = __webpack_public_path__ + "media/images/banner/klook/sp/rental-o_360_360_zh-hant-a568724280315cf469d9c7d6abfca83a.jpg";